export default __webpack_public_path__ + "static/media/servicePositive.1fcf1517.webp";